"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondTransferCancelRequestRequest = void 0;
var SecondTransferCancelRequestRequest = /** @class */ (function () {
    function SecondTransferCancelRequestRequest() {
    }
    return SecondTransferCancelRequestRequest;
}());
exports.SecondTransferCancelRequestRequest = SecondTransferCancelRequestRequest;
;
//# sourceMappingURL=secondTransferCancelRequest.request.js.map